import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { SETTINGS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MenuLabelsPage } from '@/features/menuLabels/pages/MenuLabelsPage';

export const Route = createFileRoute('/_auth/settings/menu-labels')({
  beforeLoad: () => requirePermission(SETTINGS_PERMISSIONS.MENU_LABELS_EDIT),
  component: () => (
    <ErrorBoundary moduleName="Menu Labels">
      <Suspense fallback={<PageLoader />}>
        <MenuLabelsPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
